export default function initEvents(root = document) {
  const modules = root.matches?.(".sz-events")
    ? [root]
    : root.querySelectorAll(".sz-events");

  modules.forEach((module) => {
    if (module.dataset.eventsInitialised === "true") return;
    module.dataset.eventsInitialised = "true";

    const toggle = module.querySelector(".sz-events__toggle");
    const extraItems = module.querySelectorAll(".sz-events__item--extra");

    if (!toggle || !extraItems.length) return;

    toggle.addEventListener("click", () => {
      module.classList.add("sz-events--expanded");
      toggle.setAttribute("aria-expanded", "true");

      extraItems.forEach((item) => {
        item.hidden = false;
      });

      toggle.remove();
    });
  });
}
